module.exports = __webpack_public_path__ + "img/3_85.7ebb2ecb.png";